import useSWRImmutable from "swr/immutable";

import { getFeatureFlag } from "../../constants/featureFlags";

import type { FeatureFlag } from "../../constants/featureFlags";

const getSignedUrlFeatureFlag = async (): Promise<FeatureFlag | undefined> => {
  return await getFeatureFlag("signedUrl");
};

/**
 * TODO: enableXXX.tsがほぼ同じロジックになっているため、共通化する
 */
export const useEnableSignedUrl = (
  eventId: string | undefined
): boolean | undefined => {
  const { data: signedUrlFeatureFlag } = useSWRImmutable<FeatureFlag>(
    "getSignedUrlFeatureFlag",
    async () => {
      let flag: FeatureFlag | undefined;
      try {
        flag = await getSignedUrlFeatureFlag();
      } catch (error) {
        console.debug("Failed to fetch signedUrl feature flag:", error);
        return {
          globalEnabled: false,
          events: {},
        };
      }
      if (flag === undefined) {
        return {
          globalEnabled: false,
          events: {},
        };
      }
      return flag;
    }
  );

  try {
    // loading
    if (signedUrlFeatureFlag === undefined) {
      return undefined;
    }

    if (signedUrlFeatureFlag.globalEnabled) {
      return true;
    }
    if (eventId && signedUrlFeatureFlag.events[eventId]) {
      return true;
    }

    return false;
  } catch (error) {
    return false;
  }
};
